import {useStoredIsOnline} from "../store/is-online";

export default function ConnectionBanner() {
  const isOnline = useStoredIsOnline();

  if (isOnline) return null;

  return (
    <div className="flex justify-center items-center min-h-2rem w-full  font-semibold p-2 from-yellow-200 to-yellow-300 bg-gradient-to-t">
      <div className="flex items-center">
        <i className="pi pi-exclamation-triangle mr-2" />
        <span className="text-sm text-center">
          Connection lost. You can continue to working offline with limited functionality.
        </span>
      </div>
    </div>
  );
}
